export default {
  init() {

////////////////////////////////////////
// section > modernizr
////////////////////////////////////////  
/*! modernizr 3.6.0 (Custom Build) | MIT *
 * https://modernizr.com/download/?-touchevents-setclasses !*/
!function(e,n,t){function o(e,n){return typeof e===n}function s(){var e,n,t,s,a,i,r;for(var l in c)if(c.hasOwnProperty(l)){if(e=[],n=c[l],n.name&&(e.push(n.name.toLowerCase()),n.options&&n.options.aliases&&n.options.aliases.length))for(t=0;t<n.options.aliases.length;t++)e.push(n.options.aliases[t].toLowerCase());for(s=o(n.fn,"function")?n.fn():n.fn,a=0;a<e.length;a++)i=e[a],r=i.split("."),1===r.length?Modernizr[r[0]]=s:(!Modernizr[r[0]]||Modernizr[r[0]]instanceof Boolean||(Modernizr[r[0]]=new Boolean(Modernizr[r[0]])),Modernizr[r[0]][r[1]]=s),f.push((s?"":"no-")+r.join("-"))}}function a(e){var n=u.className,t=Modernizr._config.classPrefix||"";if(p&&(n=n.baseVal),Modernizr._config.enableJSClass){var o=new RegExp("(^|\\s)"+t+"no-js(\\s|$)");n=n.replace(o,"$1"+t+"js$2")}Modernizr._config.enableClasses&&(n+=" "+t+e.join(" "+t),p?u.className.baseVal=n:u.className=n)}function i(){return"function"!=typeof n.createElement?n.createElement(arguments[0]):p?n.createElementNS.call(n,"http://www.w3.org/2000/svg",arguments[0]):n.createElement.apply(n,arguments)}function r(){var e=n.body;return e||(e=i(p?"svg":"body"),e.fake=!0),e}function l(e,t,o,s){var a,l,f,c,d="modernizr",p=i("div"),h=r();if(parseInt(o,10))for(;o--;)f=i("div"),f.id=s?s[o]:d+(o+1),p.appendChild(f);return a=i("style"),a.type="text/css",a.id="s"+d,(h.fake?h:p).appendChild(a),h.appendChild(p),a.styleSheet?a.styleSheet.cssText=e:a.appendChild(n.createTextNode(e)),p.id=d,h.fake&&(h.style.background="",h.style.overflow="hidden",c=u.style.overflow,u.style.overflow="hidden",u.appendChild(h)),l=t(p,e),h.fake?(h.parentNode.removeChild(h),u.style.overflow=c,u.offsetHeight):p.parentNode.removeChild(p),!!l}var f=[],c=[],d={_version:"3.6.0",_config:{classPrefix:"",enableClasses:!0,enableJSClass:!0,usePrefixes:!0},_q:[],on:function(e,n){var t=this;setTimeout(function(){n(t[e])},0)},addTest:function(e,n,t){c.push({name:e,fn:n,options:t})},addAsyncTest:function(e){c.push({name:null,fn:e})}},Modernizr=function(){};Modernizr.prototype=d,Modernizr=new Modernizr;var u=n.documentElement,p="svg"===u.nodeName.toLowerCase(),h=d._config.usePrefixes?" -webkit- -moz- -o- -ms- ".split(" "):["",""];d._prefixes=h;var m=d.testStyles=l;Modernizr.addTest("touchevents",function(){var t;if("ontouchstart"in e||e.DocumentTouch&&n instanceof DocumentTouch)t=!0;else{var o=["@media (",h.join("touch-enabled),("),"heartz",")","{#modernizr{top:9px;position:absolute}}"].join("");m(o,function(e){t=9===e.offsetTop})}return t}),s(),a(f),delete d.addTest,delete d.addAsyncTest;for(var v=0;v<Modernizr._q.length;v++)Modernizr._q[v]();e.Modernizr=Modernizr}(window,document);

////////////////////////////////////////
// section > get parameter in url
////////////////////////////////////////  
var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = decodeURIComponent(window.location.search.substring(1)),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : sParameterName[1];
        }
    }
};

////////////////////////////////////////
// section > vars
////////////////////////////////////////  
var $document = $(document);
var $html = $('html');
var $body = $('body');
var $window = $(window);
var $shell = $html.add($body);
var scrollSpeed = 500;



// $('button.headerSearchLink').on('click', function() {
//   console.log('ahsd');
// });

setTimeout(function() {
  // prevent opacity flash
  $('.headerSearchInput').addClass('init');
}, 300);


// JavaScript to be fired on all pages
$(".page-content").fitVids({
  ignore: '.storyBlock__main'
  // customSelector: "iframe[src^='https://w.soundcloud.com']" // DON'T USE THIS!  MESSES UP HOW THESE IFRAMES SHOULD WORK!
});


////////////////////////////////////////
// section > data selectize
////////////////////////////////////////  
$('[data-selectize]').selectize();

////////////////////////////////////////
// section > open links in new tab
////////////////////////////////////////	
$('a[href]').each(function() {
   var a = new RegExp('/' + window.location.host + '/');
   if(!a.test(this.href)) {
       $(this).click(function(event) {
           event.preventDefault();
           event.stopPropagation();
           window.open(this.href, '_blank');
       });
   }
});

////////////////////////////////////////
// section > object fit images
////////////////////////////////////////	
objectFitImages();

////////////////////////////////////////
// section > acvocacy center
////////////////////////////////////////	
var $advocacySmallBlocks = $('.advocacyGroup .advocacySmallBlock');
var $advocacyMainBlocks = $('.advocacyGroup .advocacyMainBlock');
var $allAdvocacyBlocks = $advocacySmallBlocks.add($advocacyMainBlocks);
$advocacySmallBlocks.each(function() {
	var $this = $(this);
	var thisIndex = $this.parent().index();
	var $thisAssociatedMainBlock = $advocacyMainBlocks.eq(thisIndex);
	$this.on('click', function() {
		$allAdvocacyBlocks.removeClass('active');
		$this.add($thisAssociatedMainBlock).addClass('active');
	});
});

////////////////////////////////////////
// section > sliders
////////////////////////////////////////  
$('.wellnessSlickTop').slick( {
  asNavFor: '.wellnessSlickBottom',
  prevArrow: '<a class="mobileSlickArrow prev" role="button"><i class="ml-symone-68-arrow-left-right-up-down-increase-decrease"></i></a>',
  nextArrow: '<a class="mobileSlickArrow next" role="button"><i class="ml-symone-68-arrow-left-right-up-down-increase-decrease"></i></a>',
});
$('.wellnessSlickBottom').slick( {
  asNavFor: '.wellnessSlickTop',
  arrows: false,
});

var urlHash = window.location.hash;
if(urlHash)  {
  $window.on('load', function() {
    $('html,body').animate({ scrollTop: $(urlHash).offset().top - 20 }, scrollSpeed); 
  });
  setTimeout(function() {
    $('[data-click-if-hash="'+urlHash+'"]').click();  
  }, scrollSpeed);
  
}


$document.on('click', 'a[href^="#"]', function(e) { 
  e.preventDefault(); 
  var dest = $(this).attr('href'); 
  $('html,body').animate({ scrollTop: $(dest).offset().top - 20 }, scrollSpeed); 
});

function makeSafeForCSS(name) {
    return name.replace(/[^a-z0-9]/g, function(s) {
        var c = s.charCodeAt(0);
        if (c == 32) return '-';
        if (c >= 65 && c <= 90) return '_' + s.toLowerCase();
        return '__' + ('000' + c.toString(16)).slice(-4);
    });
}
////////////////////////////////////////
// section > create sublinks nav
////////////////////////////////////////  
var $subSectionStartHeaders = $('.subSectionStart');
var backToTopHtml = '<div class="backToTop"><a role="button" class="backToTop__link">Back to Top</a></div>';


// build nav
var subsectionNavHtml = '<div class="subSectionNav">';
subsectionNavHtml += '<div class="subSectionNav__header">Jump to a topic</div>';
subsectionNavHtml += '<div id="anchorNavWrap">';
subsectionNavHtml += '<ul class="nav">';

$subSectionStartHeaders.each(function() {
  var $this = $(this);
  var thisText = $this.text();
  var thisId = makeSafeForCSS(thisText);   
  subsectionNavHtml += '<li class="subSectionNav__item nav-item"><a href="#'+thisId+'" class="nav-link subSectionNav__link">'+thisText+'</a></li>';
});

subsectionNavHtml += '</ul>';
subsectionNavHtml += '</div>';
subsectionNavHtml += '</div>';



// output nav and final "back to top" link
if($subSectionStartHeaders.length)  {
  $('.subSectionStart').first().before(backToTopHtml);
  $('.sidebarBlocks').prepend(subsectionNavHtml);
}


// wrap all subsections in divs
$subSectionStartHeaders.each(function() {
  var $this = $(this);
  var thisText = $this.text();
  var thisId = makeSafeForCSS(thisText);
  // $this.add($this.nextUntil('.backToTop').addBack()).wrapAll('<div class="subSectionWrap" id="'+thisId+'" />');
  $this.add($this.nextUntil('.subSectionStart')).wrapAll('<div class="subSectionWrap" id="'+thisId+'" />');
  $this.parent().append(backToTopHtml); 
});




var scrollOffset = 20;


if($subSectionStartHeaders.length)  {
  setTimeout(function() {
    $(".sidebarBlocks").stick_in_parent( {
      offset_top: scrollOffset
    });    
    $('body').scrollspy({ 
      target: '#anchorNavWrap',
      offset: scrollOffset + 2
    });
  }, 200);
}

$document.on('click', '.backToTop__link', function() {
  $shell.animate({ scrollTop: 0 }, scrollSpeed);
});

////////////////////////////////////////
// section > scroll spy
////////////////////////////////////////  


////////////////////////////////////////
// section > add/remove/toggle classes
////////////////////////////////////////  
$('[data-target-class]').each(function() {
  var $this = $(this);
  var targetClass = $this.data('target-class');
  var $thisTargetElement = $this.data('target-element');
  // var $thisTargetEvent = 
  if(typeof($thisTargetElement) == 'undefined')  {
    $thisTargetElement = $body;
  }
  $this.on('click', function() {
    
    if($this.is('[data-toggle-class]'))  {
      $thisTargetElement.toggleClass(targetClass);
    }
    else if($this.is('[data-remove-class]'))  {
      $thisTargetElement.removeClass(targetClass);
    }
    else if($this.is('[data-add-class]'))  {
      $thisTargetElement.addClass(targetClass);
    }
    return false;
  });
  
});

////////////////////////////////////////
// section > 2nd tier mobile nav
////////////////////////////////////////  
var $mobileNavTiersWrapItems = $('.mobileNavTiersWrap__item');
$('.headerNav--mobile .withSubNav').each(function() {
  var $this = $(this);
  var thisIndex = $this.index();
  var $targetTier = $mobileNavTiersWrapItems.eq(thisIndex);
  $this.find('.headerNav__top .triggerMobilePanel2').on('click', function() {
     $mobileNavTiersWrapItems.hide();
     $targetTier.show();
     $body.addClass('mobileMenu2');
     return false;
  });

});

////////////////////////////////////////
// section >  select change on page load
////////////////////////////////////////  
$("[data-select-change]").each(function() {
  var $this = $(this);
  $this.val($this.data('select-change'));
});

////////////////////////////////////////
// section > isotope
////////////////////////////////////////  
// $(window).on('load', function() {

//   $('.isotope').each(function() {
//     var $this = $(this);
    
//   });

// });

////////////////////////////////////////
// section > collapse items depending on checked categories
////////////////////////////////////////  

$(window).on('load', function() {

  $('.filterableContentWrap').each(function() {
    var $this = $(this);
    var $thisCheckboxes = $this.find('input[name="categories[]"]');
    var $thisPanels = $this.find('.isotope__item');
    var $isotope = $this.find('.isotope');
    var $categoryGroups = $this.find('.categoryGroup');
    var isotopeInstance;
    if($isotope.length)  {
      isotopeInstance = $isotope.isotope({
        itemSelector: '.isotope__item',
        layoutMode: 'fitRows'
      }); 
    }
    


    $thisCheckboxes.on('change', function() {
      var $checkedItems = $thisCheckboxes.filter(":checked");
      var selectorChain = '';
      $checkedItems.each(function() {
        selectorChain += '.' + $(this).val();
      });


      if($isotope.length)  {
          isotopeInstance.isotope({ filter: selectorChain });
      }
      else  {
        if(selectorChain == '')  {
           $thisPanels.collapse('show');          
        }
        else  {
          var $panelstoShow = $thisPanels.filter(selectorChain);
          var $panelstoHide = $thisPanels.not($panelstoShow);
          $panelstoHide.collapse('hide');
          $panelstoShow.collapse('show');          
        }          
      }
      var filterString = '?filter=';
      var filtersArr = [];
      $checkedItems.each(function() {
        var $thisCheckedItem = $(this);
        var thisCheckedItemVal = $thisCheckedItem.val();
        filtersArr.push(thisCheckedItemVal);
      });
      
      filterString += filtersArr.join('+');
      if(filtersArr.length === 0)  {
        window.history.replaceState(null, null, window.location.pathname);
      }
      else  {
        history.pushState('', '', filterString);
      }
      

    
    });
  });
  
  ////////////////////////////////////////
  // section > filters > dynamically check 
  // boxes based on filter parameter
  ////////////////////////////////////////  
  var filters = getUrlParameter('filter');
  if(filters)  {
    var $filtersGroupInputs = $('.filtersGroup input');
    var $filtersPanel__header = $('.filtersPanel__header');
    var filtersArr = filters.split("+");
    for (var i = filtersArr.length - 1; i >= 0; i--) {
      var $targetFilterInput = $filtersGroupInputs.filter(function() {
        if($(this).attr('value') == filtersArr[i])  {
          return true;
        }
      });
      if($targetFilterInput.length)  {
        console.log(filtersArr[i]);
      }
      $targetFilterInput.prop('checked', true).trigger('change');
    }  
    $filtersPanel__header.click();
  }


}); // window on load


////////////////////////////////////////
// section > dynamically insert html into embed descriptions
////////////////////////////////////////  
var $embedDescriptionModalTitle = $('#embedDescriptionModal .modal-title');
var $embedDescriptionModalContent = $('#embedDescriptionModal .modal-body');
$('.embedBlock').each(function() {
  var $this = $(this);
  var $thisDescriptionLink = $this.find(".embedBlock__descriptionLink");
  var thisDescriptionHtml = $this.find('.embedBlock__descriptionBody').html();
  var thisTitle = $this.find('.embedBlock__header').text();
  $thisDescriptionLink.on('click', function() {
    $embedDescriptionModalTitle.text(thisTitle);
    $embedDescriptionModalContent.html(thisDescriptionHtml);
  });

});



////////////////////////////////////////
// section > video embed modal
////////////////////////////////////////  
if(!Modernizr.touch)  {
  var $videoEmbedModal = $('.videoEmbedModal');
  var $videoEmbedModalContent = $('.videoEmbedModal .dynamicVideoEmbedWrap');
  $('.triggerNoTouchVideo').each(function() {
    var $this = $(this);
    var thisIframeSrc = $this.data('autoplay-video-url');
    var iframeHtml = '<iframe src="' + thisIframeSrc + '" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>';
    $this.on('click', function() {
      $videoEmbedModalContent.html(iframeHtml);
    });
  });

  $videoEmbedModal.on('hidden.bs.modal', function() {
    $videoEmbedModalContent.html('');
  });
}


////////////////////////////////////////
// section > trigger modals with hashes that relate to the modal id
////////////////////////////////////////  
var $hashModal = $(window.location.hash);
console.log(window.location.hash);
if($hashModal.hasClass('modal'))  {
  $hashModal.modal('show');
}

$('.modal').each(function() {
  var $this = $(this);
  var $associatedLinks = $('a[href="#'+$this.attr('id')+'"]');
  $associatedLinks.on('click', function() {
    $this.modal('show');
    return false;
  });
});

////////////////////////////////////////
// section > url select
////////////////////////////////////////  
$('.urlSelect').on('change', function() {
  window.location.href = $(this).val();
});



////////////////////////////////////////
// section > less sensitive meganav
////////////////////////////////////////  
$('.withSubNav').each(function() {
  var $this = $(this);
  $this.on('mouseenter', function() {
    setTimeout(function() {
      $this.addClass('hover');
    }, 300);
  }).on('mouseleave', function() {
    $this.removeClass('hover');
  });
});

////////////////////////////////////////
// section > contact form 7 get parameters
////////////////////////////////////////  
var supportSearchZipcode = getUrlParameter('zip');
var supportSearchMiles = getUrlParameter('miles');
if(supportSearchZipcode && supportSearchMiles)  {
  $('[name="zip"]').val(supportSearchZipcode);
  $('[name="miles"]').val(supportSearchMiles);
}


////////////////////////////////////////
// section > end
////////////////////////////////////////	

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js